import React, { useMemo, useState, useEffect } from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

/**
 * ✅ ODRŽAVANJE LISTE (dodaj/izmijeni/obriši):
 * - Samo mijenjaš PUBLICATIONS array ispod.
 * - Redoslijed je namjerno isti kao što je bio na stranici.
 */
const PUBLICATIONS = [
  {
    title: "Kvantitativne metode",
    authors: "Ruzica Stankovic, Milovan Zivkovic",
    isbn: "978-9940-627-00-3",
  },
  {
    title: "Ekonomija",
    authors: "Dudan S. Zdravkovic, Veselin Orlandic",
    isbn: "978-9940-35-000-0",
  },
  {
    title: "Marketing",
    authors: "Radovan Knezevic",
    isbn: "978-9940-35-001-7",
  },
  {
    title: "Menadzment ljudskih resursa",
    authors: "Rajko Novicevic",
    isbn: "978-9940-35-002-4",
  },
  {
    title: "Menadzment",
    authors: "Veselin Orlandic",
    isbn: "978-9940-35-003-1",
  },
  {
    title: "Poslovno pravo",
    authors: "Dragan Lekic, Goran Sljivancanin",
    isbn: "978-9940-35-004-8",
  },
  {
    title: "Osnovi racunovodstva",
    authors: "Dusan S. Milojevic",
    isbn: "978-9940-35-005-5",
  },
  {
    title: "Poslovno odlucivanje",
    authors: "Dragan D. Zdravkovic",
    isbn: "978-9940-35-006-2",
  },
  {
    title: "Poslovna ekonomika",
    authors: "Momcilo Zivkovic",
    isbn: "978-9940-35-007-9",
  },
  {
    title: "Kvantitativne metode",
    authors: "Aleksa Macanovic, Milovan Zivkovic",
    isbn: "978-9940-35-008-6",
  },
  {
    title: "Poslovna ekonomika",
    authors: "Momcilo Zivkovic",
    isbn: "978-9940-35-009-3",
  },
  {
    title: "Metod studentske prakse i praktične nastave",
    authors: "Bozo Mardjokic",
    isbn: "978-9940-35-010-9",
  },
  {
    title: "Poslovne komunikacije i organizaciono ponašanje",
    authors: "Veselin Orlandic",
    isbn: "978-9940-35-011-6",
  },
  {
    title: "Poslovno pravo",
    authors: "Dragan L. Lekic",
    isbn: "978-9940-35-012-3",
  },
  {
    title: "Uvod u racunovodstvo",
    authors: "S. Grebovic, M. Hajdarpasic",
    isbn: "978-9940-35-013-0",
  },
  {
    title: "Logistika",
    authors: "D. Radoman, B. Mijovic",
    isbn: "978-9940-35-014-7",
  },
  {
    title: "Materijali za pripremu ispita iz predmeta Menadzment",
    authors: "R. Novicevic",
    isbn: "978-9940-35-015-4",
  },
  {
    title: "Bankarstvo",
    authors: "D. Zdravkovic, M. Vukicevic",
    isbn: "978-9940-35-016-1",
  },
  {
    title: "Ekološki menadzment",
    authors: "M. Zivkovic",
    isbn: "978-9940-35-017-8",
  },
  {
    title: "Revizija finansijskih iskaza",
    authors: "D. Zdravkovic",
    isbn: "978-9940-35-018-5",
  },
  {
    title: "Poslovne finansije",
    authors: "D. Zdravkovic",
    isbn: "978-9940-35-019-2",
  },
  {
    title: "Preduzetništvo",
    authors: "M. Zivkovic, S. Djurovic",
    isbn: "978-9940-35-020-8",
  },
  {
    title: "Upravljacko racunovodstvo",
    authors: "S. Grebovic",
    isbn: "978-9940-35-021-5",
  },
  {
    title: "Menadzment neprofitnih organizacija",
    authors: "I. Rasovic",
    isbn: "978-9940-35-022-2",
  },
  {
    title: "Menadzment malih i srednjih preduzeca",
    authors: "I. Rasovic",
    isbn: "978-9940-35-023-9",
  },
  {
    title: "Monetarne i javne finansije",
    authors: "D. S. Zdravkovic",
    isbn: "978-9940-35-024-6",
  },
  {
    title: "Strategijski menadzment",
    authors: "B. Mijovic",
    isbn: "978-9940-35-025-3",
  },
  {
    title: "Carinsko poslovanje",
    authors: "M. Zivkovic, M. Zivkovic",
    isbn: "978-9940-35-026-0",
  },
  {
    title: "Upravljanje kvalitetom",
    authors: "M. Zivanovic, S. Zivanovic, I. Zivanovic",
    isbn: "978-9940-35-027-7",
  },
  {
    title: "Analiza poslovanja",
    authors: "S. Grebovic, M. Hajdarpasic",
    isbn: "978-9940-35-028-4",
  },
  {
    title: "Finansijska tržišta i berzansko poslovanje",
    authors: "D. Zdravkovic",
    isbn: "978-9940-35-029-1",
  },
  {
    title: "Business English",
    authors: "Lj. Jovkovic (2 knjige)",
    isbn: "978-9940-35-030-7, 978-9940-35-031-4",
  },
  {
    title: "Medjunarodna spedicija, transport i osiguranje",
    authors: "M. Zivkovic",
    isbn: "978-9940-35-032-1",
  },
  {
    title: "Principi marketinga",
    authors: "Rade Kancir",
    isbn: "978-9940-35-033-8",
  },
  {
    title: "Menadzment održivog razvoja i životne sredine",
    authors: "M. Zivanovic",
    isbn: "978-9940-35-034-5",
  },
  {
    title: "Osnovi marketinga",
    authors: "R. Knezevic, D. Medenica",
    isbn: "978-9940-35-035-2",
  },
  {
    title: "Menadzment ljudskih resursa",
    authors: "R. Novicevic, N. Abramovic",
    isbn: "978-9940-35-036-9",
  },
  {
    title: "Model studentske prakse i praktična nastava akademskih studija",
    authors: "B. Mardjokic",
    isbn: "978-9940-35-037-6",
  },
  {
    title: "Elektronsko poslovanje",
    authors: "A. Macanovic, N. Abramovic",
    isbn: "978-9940-35-039-0",
  },
  {
    title: "Menadzment neprofitnih organizacija",
    authors: "I. Rasovic",
    isbn: "978-9940-35-038-3",
  },
];

function normalize(s) {
  return (s || "").toString().toLowerCase().trim();
}

function IzdavackaDjelatnost() {
  const [t] = useTranslation();

  const [query, setQuery] = useState("");
  const [sort, setSort] = useState("default"); // default | title
  const [visibleCount, setVisibleCount] = useState(12);

  const homeLabel = t("breadcrumb.home", { defaultValue: "Početna" });
  const pageTitle = t("izdavacka.title", {
    defaultValue: "Izdavačka djelatnost",
  });

  const filtered = useMemo(() => {
    const q = normalize(query);
    const base = PUBLICATIONS.map((p, idx) => ({ ...p, _idx: idx }));

    const out = q
      ? base.filter((p) => {
          const hay = `${p.title} ${p.authors} ${p.isbn}`.toLowerCase();
          return hay.includes(q);
        })
      : base;

    if (sort === "title") {
      return [...out].sort((a, b) => a.title.localeCompare(b.title, "sr-Latn"));
    }

    return out.sort((a, b) => a._idx - b._idx);
  }, [query, sort]);

  const visible = useMemo(
    () => filtered.slice(0, visibleCount),
    [filtered, visibleCount],
  );

  useEffect(() => {
    // Kad se promijeni pretraga ili sortiranje, resetuj “show more” da UX bude čist.
    setVisibleCount(12);
  }, [query, sort]);

  return (
    <>
      <Navbar />
      <Bredcom title={homeLabel} subtitle={pageTitle} />

      <div className="publishing-page">
        <div className="container mt-4 pt-40">
          <div className="row">
            {/* MAIN */}
            <div className="col-md-8">
              <div className="content-container publishing-content">
                {/* HERO */}
                <section className="publishing-hero" aria-label={pageTitle}>
                  <div className="publishing-hero__top">
                    <span className="publishing-pill">
                      <i className="fas fa-book-open" aria-hidden="true" />
                      {t("izdavacka.ui.badge")}
                    </span>

                    <div className="publishing-hero__meta">
                      <span className="publishing-chip">
                        <i className="fas fa-list" aria-hidden="true" />
                        {t("izdavacka.ui.total", {
                          count: PUBLICATIONS.length,
                        })}
                      </span>
                      <span className="publishing-chip">
                        <i className="fas fa-search" aria-hidden="true" />
                        {t("izdavacka.ui.searchable")}
                      </span>
                    </div>
                  </div>

                  <h2 className="section-title publishing-title">
                    {pageTitle}
                  </h2>

                  {/* ORIGINAL TEXT (kept) */}
                  <p className="publishing-lead">
                    {t("izdavacka.koizdavac")}{" "}
                    <a
                      href="https://www.vspv.si/sl/publikacije/ipr"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="publishing-link"
                    >
                      <strong>IPR</strong>{" "}
                      <i
                        className="fas fa-external-link-alt"
                        aria-hidden="true"
                      />
                    </a>
                    .
                  </p>

                  <div className="publishing-callout">
                    <i className="fas fa-info-circle" aria-hidden="true" />
                    <div>
                      <div className="publishing-callout__title">
                        {t("izdavacka.ui.noteTitle")}
                      </div>
                      <div className="publishing-callout__text">
                        {t("izdavacka.ui.noteText")}
                      </div>
                    </div>
                  </div>
                </section>

                {/* CONTROLS */}
                <section
                  id="publikacije"
                  className="publishing-controls"
                  aria-label={t("izdavacka.nekeod")}
                >
                  <div className="publishing-controls__head">
                    <h3 className="subsection-title publishing-subtitle">
                      {t("izdavacka.nekeod")}
                    </h3>
                    <div className="publishing-count">
                      {t("izdavacka.ui.results", {
                        shown: Math.min(visible.length, filtered.length),
                        total: filtered.length,
                      })}
                    </div>
                  </div>

                  <div className="publishing-controls__row">
                    <label
                      className="publishing-search"
                      aria-label={t("izdavacka.ui.searchLabel")}
                    >
                      <i className="fas fa-search" aria-hidden="true" />
                      <input
                        value={query}
                        onChange={(e) => setQuery(e.target.value)}
                        placeholder={t("izdavacka.ui.searchPlaceholder")}
                      />
                      {query ? (
                        <button
                          type="button"
                          className="publishing-clear"
                          onClick={() => setQuery("")}
                          aria-label={t("izdavacka.ui.clear")}
                          title={t("izdavacka.ui.clear")}
                        >
                          <i className="fas fa-times" aria-hidden="true" />
                        </button>
                      ) : null}
                    </label>

                    <div
                      className="publishing-sort"
                      aria-label={t("izdavacka.ui.sortLabel")}
                    >
                      <span className="publishing-sort__label">
                        {t("izdavacka.ui.sortLabel")}
                      </span>
                      <select
                        value={sort}
                        onChange={(e) => setSort(e.target.value)}
                      >
                        <option value="default">
                          {t("izdavacka.ui.sortDefault")}
                        </option>
                        <option value="title">
                          {t("izdavacka.ui.sortTitle")}
                        </option>
                      </select>
                    </div>
                  </div>
                </section>

                {/* LIST */}
                <section
                  className="publishing-grid"
                  role="list"
                  aria-label={t("izdavacka.ui.gridAria")}
                >
                  {visible.map((p, idx) => {
                    const key = `${p.isbn}-${idx}`;
                    return (
                      <article
                        className="publishing-card"
                        role="listitem"
                        key={key}
                      >
                        <div
                          className="publishing-card__icon"
                          aria-hidden="true"
                        >
                          <i className="fas fa-book" />
                        </div>

                        <div className="publishing-card__body">
                          <div className="publishing-card__title">
                            {p.title}
                          </div>

                          <div className="publishing-card__authors">
                            <i
                              className="fas fa-user-edit"
                              aria-hidden="true"
                            />
                            <span>{p.authors}</span>
                          </div>

                          <div className="publishing-card__isbn">
                            <span className="publishing-badge">ISBN</span>
                            <span className="publishing-isbn">{p.isbn}</span>
                          </div>
                        </div>
                      </article>
                    );
                  })}

                  {filtered.length === 0 ? (
                    <div className="publishing-empty">
                      <i className="far fa-folder-open" aria-hidden="true" />
                      <div>
                        <div className="publishing-empty__title">
                          {t("izdavacka.ui.noResultsTitle")}
                        </div>
                        <div className="publishing-empty__text">
                          {t("izdavacka.ui.noResultsText")}
                        </div>
                      </div>
                    </div>
                  ) : null}
                </section>

                {/* SHOW MORE */}
                {filtered.length > visibleCount ? (
                  <div className="publishing-more">
                    <button
                      type="button"
                      className="pub-btn pub-btn--primary"
                      onClick={() =>
                        setVisibleCount((n) =>
                          Math.min(n + 12, filtered.length),
                        )
                      }
                    >
                      {t("izdavacka.ui.showMore")}
                      <i className="fas fa-chevron-down" aria-hidden="true" />
                    </button>
                  </div>
                ) : filtered.length > 12 ? (
                  <div className="publishing-more">
                    <button
                      type="button"
                      className="pub-btn pub-btn--ghost"
                      onClick={() =>
                        window.scrollTo({ top: 0, behavior: "smooth" })
                      }
                    >
                      {t("izdavacka.ui.backToTop")}
                      <i className="fas fa-chevron-up" aria-hidden="true" />
                    </button>
                  </div>
                ) : null}
              </div>
            </div>

            {/* SIDEBAR (keep existing structure, just add quick nav on top) */}
            <div className="col-md-4 pt-10">
              <aside className="sidebar-widget publishing-sidebar">
                <section className="widget widget_categories">
                  <h2 className="widget-title">
                    {t("izdavacka.ui.quickTitle")}
                  </h2>
                  <ul className="publishing-quicknav">
                    <li>
                      <a href="#publikacije">
                        <i className="fas fa-list" aria-hidden="true" />
                        {t("izdavacka.ui.quickPublications")}
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.vspv.si/sl/publikacije/ipr"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i
                          className="fas fa-external-link-alt"
                          aria-hidden="true"
                        />
                        {t("izdavacka.ui.quickIpr")}
                      </a>
                    </li>
                  </ul>
                </section>

                <section
                  id="custom_html-5"
                  className="widget_text widget widget_custom_html"
                >
                  <h2 className="widget-title">{t("sidebar.follow")}</h2>
                  <div className="textwidget custom-html-widget">
                    <div className="widget-social">
                      <a
                        href="https://www.facebook.com/fpebar.me"
                        target="_blank"
                        rel="noopener noreferrer"
                        title="Facebook"
                      >
                        <i className="fab fa-facebook-f" />
                      </a>
                      <a
                        href="https://www.instagram.com/fpepbar/"
                        target="_blank"
                        rel="noopener noreferrer"
                        title="Instagram"
                      >
                        <i className="fab fa-instagram" />
                      </a>
                      <a
                        href="https://www.youtube.com/@fpepbar"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fab fa-youtube" />
                      </a>
                      <a
                        href="https://www.tiktok.com/@fpepbar"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Follow us on Tiktok"
                        title="Tiktok"
                      >
                        <i className="fab fa-tiktok" />
                      </a>
                      <a
                        href="https://www.linkedin.com/school/fpepbar/"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Follow us on LinkedIn"
                        title="LinkedIn"
                      >
                        <i className="fab fa-linkedin-in" />
                      </a>
                    </div>
                  </div>
                </section>

                <section id="categories-1" className="widget widget_categories">
                  <h2 className="widget-title">{t("sidebar.useful")}</h2>
                  <ul>
                    <li className="cat-item cat-item-16">
                      <Link to="/o-fpep">{t("about.fpep")}</Link>
                    </li>
                    <li className="cat-item cat-item-23">
                      <Link to="/akreditacija-fpep">
                        {t("admission.Akreditacija")}
                      </Link>
                    </li>
                    <li className="cat-item cat-item-18">
                      <Link to="/upis">{t("upis.title")}</Link>
                    </li>
                    <li className="cat-item cat-item-22">
                      <Link to="/cijene-studija">
                        {t("admission.Skolarina")}
                      </Link>
                    </li>
                    <li className="cat-item cat-item-22">
                      <Link to="/erasmus">{t("saradnja.erasmus")}</Link>
                    </li>
                    <li className="cat-item cat-item-22">
                      <Link to="/projekti">{t("saradnja.projekti")}</Link>
                    </li>
                    <li className="cat-item cat-item-22">
                      <Link to="/dom-studenata">{t("studenti.dom")}</Link>
                    </li>
                    <li className="cat-item cat-item-22">
                      <Link to="/galerija">{t("navbar.Gallery")}</Link>
                    </li>
                    <li className="cat-item cat-item-22">
                      <Link to="/novosti">{t("navbar.News")}</Link>
                    </li>
                  </ul>
                </section>

                <section
                  id="recent-posts-4"
                  className="widget widget_recent_entries"
                >
                  <h2 className="widget-title">{t("sidebar.study")}</h2>
                  <ul>
                    <li>
                      <span className="post-date">
                        <strong>{t("programs.osnovne")}</strong> <br />
                      </span>
                      <Link to="/racunovodstvo-finansije-i-bankarstvo">
                        {t("osnovne.rfb")}
                        <br />
                      </Link>
                    </li>
                    <li>
                      <Link to="/menadzment">
                        {t("osnovne.menadzment")}
                        <br />
                      </Link>
                    </li>
                    <li>
                      <Link to="/pravo-osnovne">
                        {t("osnovne.pravo")}
                        <br />
                      </Link>
                    </li>

                    <li>
                      <span className="post-date">
                        <strong>{t("programs.master")}</strong> <br />
                      </span>
                      <Link to="/poslovna-ekonomija">
                        {t("master.poslovnaEkonomija")}
                        <br />
                      </Link>
                    </li>
                    <li>
                      <Link to="/ekonomija-javnog-sektora">
                        {t("master.ekonomijaJavnogSektora")}
                        <br />
                      </Link>
                    </li>
                    <li>
                      <Link to="/pravo-master">
                        {t("master.pravo")}
                        <br />
                      </Link>
                    </li>

                    <li>
                      <span className="post-date">
                        <strong>{t("programs.specijalisticke")}</strong> <br />
                      </span>
                      <Link to="/menadzment-javnog-sektora-specijalisticke">
                        {t("specijalisticke.mjs")}
                        <br />
                      </Link>
                    </li>
                    <li>
                      <Link to="/menadzment-profitnog-sektora-specijalisticke">
                        {t("specijalisticke.mps")}
                        <br />
                      </Link>
                    </li>
                  </ul>
                </section>
              </aside>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default IzdavackaDjelatnost;
